(ns frontend.test.input-selection.text-simple
  (:require [reagent.core :as r]
            [ui.dom-globals :as dg]
            [ui.view.page.view :as page]))

(def state (r/atom {}))

(defn number-input
  [{:keys [value on-change]}]
  [:input {:value     value
           :on-change (fn [e]
                        (let [current-value (dg/event-target-value e)]
                          (js/console.log "Change : " current-value)
                          (on-change current-value)))}])

(defn view
  []
  [page/centered
   [number-input
    {:value (:value @state)
     :on-change
     (fn [v]
       (swap! state assoc :value v))}]])
